import styled from "styled-components"
import backgroundImage from "../../images/nda/home-offer-2.webp"

const S = {}

S.PageHeaderTitleWrapper = styled.div`
  position: relative;
  overflow: hidden;
`

S.PageHeaderTitleBackground = styled.div`
  display: flex;
  margin-top: 80px;
  justify-content: center;
  width: 100%;
  height: 30vh;
  background-image: url(${backgroundImage});
  background-position: center;
  background-size: cover;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  transition: all 1s;
  position: relative;
  transform: scale(1.2);
  filter: brightness(0.3) blur(5px);
  & :hover {
    transform: scale(1.21);
  }
`

S.Title = styled.h1`
  margin: 0;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Poppins, sans-serif;
  font-weight: 300;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 10px;

  @media (max-width: 768px) {
    top: 62%;
    font-size: 20px !important;
    letter-spacing: 4px;
  }

  &::after {
    content: "";
    width: 60px;
    height: 2px;
    background: #fff;
    position: absolute;
    bottom: -3px;
    left: 0px;
  }
`

export default S;
